import LocalizedStrings from 'react-localization';

export const commonStrings = new LocalizedStrings({
  en: {
    common: {
      time: 'Time',
      date: 'Date',
      submit: 'Submit',
      cancel: 'Cancel',
      create: 'Create',
      save: 'Save',
      back: 'Back',
      delete: 'Delete',
      update: 'Update',
      close: 'Close',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phoneNumber: 'Phone number',
      download: 'Download',
      pagination: {
        pageXOfY: (page: number, total: number) => `Page ${page} of ${total}`
      },
      search: 'Search',
      mandatory: (field: string) => `${field} is required`,
      pages: {
        home: 'Home',
        documents: 'Documents'
      },
      error: {
        error: "Error",
        generic: "An error occurred."
      }
    }
  }
});

export function withCommon<Type>(strings: Type): Type & typeof commonStrings {
  return {
    ...strings,
    ...commonStrings
  };
}

export default commonStrings;